/**
 * @generated SignedSource<<0768d75eb5d40ed6564f00ec2dada82b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LessonsFiltersFragment_facility$data = {
  readonly club: {
    readonly " $fragmentSpreads": FragmentRefs<"useGetClubStartOfWeekNumberPatron_club">;
  } | null | undefined;
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"DateSelectorControlFragment_facility" | "LessonTypeFilter_facility" | "useFacilityLessonBookingDays_facility" | "useFacilityStartEndTime_facility">;
  readonly " $fragmentType": "LessonsFiltersFragment_facility";
};
export type LessonsFiltersFragment_facility$key = {
  readonly " $data"?: LessonsFiltersFragment_facility$data;
  readonly " $fragmentSpreads": FragmentRefs<"LessonsFiltersFragment_facility">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LessonsFiltersFragment_facility",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useFacilityLessonBookingDays_facility"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "LessonTypeFilter_facility"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DateSelectorControlFragment_facility"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useFacilityStartEndTime_facility"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Club",
      "kind": "LinkedField",
      "name": "club",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useGetClubStartOfWeekNumberPatron_club"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Facility",
  "abstractKey": null
};

(node as any).hash = "a0567e62fffa31b26586c5c9bdd5c50b";

export default node;
